// @flow
import React, { Component } from 'react';
import classnames from 'classnames';
import withEscapeToDismiss from 'components/others/WithEscapeToDismiss';
import loadGoogleMaps from 'utils/google-maps';
import Config from 'config';

type Props = {
  cohortID: string,
  driverID: string,
  driverSetLocation: Function,

  handleClose: Function,
  showModal: boolean,
};

@withEscapeToDismiss()
export default class DriverLocationModal extends Component {
  constructor(props: Props) {
    super(props);
    this.state = {
      googleMapInitialized: false,
      location: null,
    };
  }

  componentDidMount() {
    if (window.google && window.google.maps) {
      // Google maps has been included before; Initialize straightaway.
      this.initializeMap();
    } else {
      window.initializeMap = this.initializeMap.bind(this);
      loadGoogleMaps(Config.GOOGLE_API_BROWSER_KEY, 'initializeMap');
    }
  }

  componentWillUnmount() {
    window.initializeMap = null;
  }

  initializeMap() {
    this.geocoder = new window.google.maps.Geocoder();
    this.setState({
      googleMapInitialized: true,
    });

    const locationInput = this.locationInput;
    const searchBox = new window.google.maps.places.SearchBox(locationInput);
    searchBox.addListener('places_changed', () => {
      const places = searchBox.getPlaces();
      if (places.length === 0) {
        return;
      }

      const location = places[0].geometry.location;
      this.setState({
        location: [location.lng(), location.lat()],
      });
    });

    locationInput.focus();
  }

  render() {
    const address = this.locationInput ? this.locationInput.value : '';
    return (
      <div
        className={classnames('modal', {
          'is-active': this.props.showModal,
        })}
        role="dialog"
      >
        <div
          className="modal-background" onClick={() => {
            this.props.handleClose();
          }}
        />
        <div className="modal-content">
          <div className="modal-box">
            <button
              aria-label="Close modal"
              className="is-pulled-right delete"
              onClick={() => {
                this.props.handleClose();
              }}
            />
            <h3 className="title is-5">Set location for Driver {this.props.driverID}</h3>
            <hr />
            <div className="field">
              <p className="control">
                <label className="label sr-only" htmlFor="address">Search address in Google</label>
                <input
                  id="address"
                  className="input"
                  type="text"
                  placeholder="Search address in Google"
                  ref={(locationInput) => { this.locationInput = locationInput; }}
                />
              </p>
            </div>
            <hr />
            <div className="field is-grouped has-text-right">
              <p className="control">
                <button
                  className="button is-outlined"
                  onClick={() => {
                    this.props.handleClose();
                  }}
                >
                  Cancel
                </button>
              </p>
              <p className="control">
                <button
                  className="button is-primary"
                  aria-label={`Set driver to address: ${address}`}
                  onClick={() => {
                    this.props.driverSetLocation(this.props.cohortID,
                      this.props.driverID, this.state.location);
                    this.props.handleClose();
                  }}
                >
                  Set Driver Location
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/js/views/dashboard/drivers/DriverLocationModal.jsx
 **/